import zh from './zh'
import en from './en'
import my from './my'
import { useUserStore } from '@/stores/user'

const langs = {
  zh,
  en,
  ms: my,
  my
}

type Key = keyof typeof zh | keyof typeof en | keyof typeof my
const lang = (key: Key, values?: Array<string | number>) => {
  const { userInfo } = useUserStore()
  const { langType } = userInfo
  const langText = langs[langType][key] || key
  if (values && values.length) {
    // 依次替换
    // let index = 0
    // return langText.replace(/{\w+}/g, () => {
    //   return index < values.length ? values[index++] + '' : ''
    // })
    // 根据{num1}替换
    // lang('当前成长值{num1}，升级黑钻还需{num4},升级黑钻还需{num2}升级黑钻还需{num3}', ['12', '13', '14', '16'])
    // 输出: "当前成长值12，升级黑钻还需16,升级黑钻还需13升级黑钻还需14" 如果数组不够会显示numN
    return langText.replace(/\{num(\d+)\}/g, (_: any, index: any) => {
      const numIndex = parseInt(index, 10) - 1
      return values[numIndex] !== undefined
        ? values[numIndex] + ''
        : `{num${index}}`
    })
  }
  return langText
}

export default lang
